import React from 'react'

const PrintDocumemtHeader = ({ docType, docInfo }) => {
    return (
        docType && docInfo ? <div className="prefaktor-print-header-container">
            <div className="prefaktor-print-header-company-name w-100 d-flex justify-content-center align-items-center flex-column">
                <h2 className="mt-2">
                    {docType === "import" ? "سند ورود به انبار" : "سند خروج از انبار"}{ }
                </h2>
                <h4 className="iranyekan-bold">
                    {`سند تحویل ${docInfo.is_trust ? "امانی" : "قطعی"}`}
                </h4>
            </div>
            <div className="prefaktor-print-header-company-name w-100 d-flex">
                <div className="prefaktor-print-header-customer-info p-3 d-flex justify-content-start flex-column">
                    <div>
                        <span className="font-size-14 me-1 iranyekan-bold">
                            تحویل گیرنده:
                        </span>
                        <span className="font-size-14 me-1">
                            {/* {`${prefaktorInfo?.people?.name} ${prefaktorInfo?.people?.family} `} */}
                            {`${docInfo.people.name} ${docInfo.people.family}` || "- - -"}
                        </span>
                    </div>

                </div>
                <div className="prefaktor-print-header-faktor-info">
                    <div>
                        <span className="font-size-14 me-1 iranyekan-bold">شماره سند:</span>
                        <span className="font-size-14 me-1">
                            {docInfo.id}
                        </span>
                    </div>
                    <div>
                        <span className="font-size-14 me-1 iranyekan-bold">تاریخ:</span>
                        <span className="font-size-14 me-1" dir="rtl">
                            {docInfo.date || null}
                        </span>
                    </div>

                </div>
            </div>
        </div>
            : null)
}

export default PrintDocumemtHeader